export const days=['', 'Hé', 'Ke', 'Sze', 'Csü', 'Pé', 'Szo', 'Va']
export const daysLong=['', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat', 'Vasárnap']
export const daysNumber=[0, 1, 2, 3, 4, 5, 6, 7]
export const daysObj = [
  {
    name: '',
    number: 0
  },
  {
    name: 'Hétfő',
    number: 1
  },
  {
    name: 'Kedd',
    number: 2
  },
  {
    name: 'Szerda',
    number: 3
  },
  {
    name: 'Csütörtök',
    number: 4
  },
  {
    name: 'Péntek',
    number: 5
  },
  {
    name: 'Szombat',
    number: 6
  },
  {
    name: 'Vasárnap',
    number: 7
  },
]